import { render, staticRenderFns } from "./commentDetailComponent.vue?vue&type=template&id=5a8de0f9&scoped=true"
import script from "./commentDetailComponent.vue?vue&type=script&lang=js"
export * from "./commentDetailComponent.vue?vue&type=script&lang=js"
import style0 from "./commentDetailComponent.vue?vue&type=style&index=0&id=5a8de0f9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8de0f9",
  null
  
)

export default component.exports